<template>
  <div class="interview">
    <gtable-crud
      ref="gtable-crud"
      :data="formatData"
      :option="option"
      :page="page"
      :loading="loading"
      :permission="permissionList"
      :before-open="beforeOpen"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @rowDel="rowDel"
      @refresh-change="refreshChange"
      @submit-add="submitAdd"
      @submit-edit="submitEdit"
    >
      <!-- 自定义列 -->
      <template
        slot="table-row"
        slot-scope="{row,column}"
      >
        <span v-if="column.field == 'form'">
          <template v-for="(item ,key) in row.form">
            <p :key="key">
              {{ $t(`_staff.labelEmploymentApplication.${key}`) }}:&nbsp;
              <span class="text-primary">{{ item }}</span>
            </p>
          </template>
        </span>
      </template>
      <template
        slot="headMenuLeft"
        slot-scope="{row}"
      >
        <my-tooltip :tooltip="$t('_components.btns.download')">
          <b-button
            variant="success"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleDownload"
          >
            <feather-icon
              icon="DownloadIcon"
              size="18"
            />
          </b-button>
        </my-tooltip>
        <!-- 新增 -->
        <my-tooltip :tooltip="$t('_components.btns.add')">
          <b-button
            v-if="isWorker"
            variant="primary"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleStepChange('add', row)"
          >
            <feather-icon
              icon="PlusIcon"
              size="18"
            />
          </b-button>
        </my-tooltip>
      </template>
      <template
        slot="menuLeft"
        slot-scope="{row}"
      >
        <!-- <my-tooltip :tooltip="$t('_components.btns.view')">
          <feather-icon
            icon="SearchIcon"
            class="text-primary cursor-pointer mr-1"
            size="20"
            @click="handleStepChange('view', row)"
          />
        </my-tooltip> -->
        <my-tooltip
          v-if="row.STATUS !== 1"
          :tooltip="$t('_components.btns.view')"
        >
          <feather-icon
            icon="SearchIcon"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleStepChange('viewPage',row)"
          />
        </my-tooltip>
        <my-tooltip :tooltip="$t('_components.btns.send')">
          <feather-icon
            v-if="getStatusOption(row.STATUS).send && isWorker"
            icon="SendIcon"
            class="text-success cursor-pointer"
            size="20"
            @click="handleStepChange('send', row)"
          />
        </my-tooltip>
        <my-tooltip
          v-if="row.STATUS == 1"
          :tooltip="$t('_components.btns.edit')"
        >
          <feather-icon
            icon="Edit2Icon"
            class="text-warning cursor-pointer ml-1"
            size="20"
            @click="handleStepChange('edit',row)"
          />
        </my-tooltip>
      </template>
    </gtable-crud>

    <c-modal
      :visible="modalShow"
      :title="modalTitle"
      size="lg"
      @close="modalShow=false"
      @modelConfirm="handleModelConfirm"
    >
      <template slot="content">
        <my-form
          v-if="getFormOption(stepMethodKey)"
          ref="overFormRef"
          :data="rowData"
          :loading="modalFormLoading"
          :option="getFormOption(stepMethodKey)"
          :footer-visible="false"
          width="auto"
        />
        <span v-else>
          {{ $t(`_staff.prompt.base.${stepMethodKey}Message`) }}
        </span>
      </template>
    </c-modal>

    <!-- 提交面试结果或者View页面 -->
    <c-drawer
      v-model="drawerShow"
      :before-close="handleBeforeClose"
    >
      <component
        :is="stepMethodKey"
        v-if="drawerShow"
        :id="processId"
        :process-id="processId"
        :form-id="formId"
        :process-key="processKey"
        :process-instance-id="findData('processInstanceId')"
        :data="findData('map')"
        @close="handleDrawerClose"
      />
    </c-drawer>

  </div>
</template>

<script>
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import CModal from '@/components/crud/modal.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import MyForm from '@/components/myForm/index.vue';
import {
  BButton, BFormRadio,
} from 'bootstrap-vue'
import { downLoadLeaveJob, downLoadAllLeaveJob } from '@/api/worker/process'
import CDrawer from '@/components/drawer.vue';
import MyTooltip from '@/components/myTooltip.vue';
import { mapGetters } from 'vuex';
import edit from '@/views/apply/components/edit.vue';
import viewPage from '@/views/apply/components/viewPage.vue';
import { templateFormat } from '@/util/func'
import { processOption } from '@/config/processOption'
// import add from './components/add.vue';
import add from '@/views/worker/apply/components/add.vue';

export default {
  components: {
    CModal,
    MyForm,
    BButton,
    add,
    edit,
    viewPage,
    CDrawer,
    MyTooltip,
    BFormRadio,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 12,
      },
      data: [],
      option: {},
      loading: false,
      drawerTitle: '',
      modalShow: false,
      drawerShow: false,
      formSelectShow: false,
      processId: '24',
      formId: '24',
      processKey: '',
      processInstanceId: '',
      stepMethodKey: '',
      rowData: {},
      modalTitle: '',
      modalFormLoading: false,
      auditLoading: false,
      formatData: [],
      formList: [
        {
          formName: '离职申请',
          id: '24',
          processKey: 'workerResign',
        },
      ],
      viewAll: false,
    };
  },
  computed: {
    ...mapGetters(['permission', 'userAllInfo']),
    isWorker() {
      return this.userAllInfo.staffId === -1
    },
    permissionList() {
      return {
        addBtn: this.permission.menu_add,
        viewBtn: this.permission.menu_view,
        delBtn: this.permission.menu_del,
        editBtn: this.permission.menu_edit,
      }
    },
    statusOption() {
      // 0已发出面试邀请 2未参加面试 4等待面试 6未通过面试
      // 8通过面试,等待反馈 10已拒绝 14已确认,等待审批 16审批中
      // 18审批失败 20审批通过 22已发出offer 24拒绝offer 26接受offer
      const option = {
        1: {
          color: 'bg-gradient-secondary',
          send: true,
        },
        5: {
          color: 'bg-gradient-warning',
        },
        7: {
          color: 'bg-gradient-danger',
        },
        9: {
          color: 'bg-gradient-success',
        },
      }
      const defaultDictArr = this.$store.getters.dicts.dictBiz
      const findDict = defaultDictArr.find(o => o.code === 'interview_ process_status')
      if (findDict) {
        findDict.children.forEach(item => {
          if (option[item.dictKey]) {
            option[item.dictKey].label = item.dictValue
          }
        });
      }
      return option
    },
  },
  watch: {
    // formId(e) {
    //   if (e) {
    //     const find = this.formList.find(o => o.id === e) || {}
    //     this.processKey = find.processKey
    //     this.processInstanceId = find.processInstanceId
    //   }
    // },
  },
  mounted() {
    const query = this.$route.query || {}
    const {
      title, processKey, formId, viewAll,
    } = this.$route.query
    this.viewAll = viewAll === 'true'
    if (query.processId) {
      this.processId = query.processId
      this.stepMethodKey = 'viewPage'
      this.drawerShow = true
      // applyAPI.workerDetail({ id: this.processId }).then(res => {
      //   const { data } = res.data
      //   this.stepMethodKey = 'viewPage'
      //   this.processKey = data.processKey
      //   this.processInstanceId = data.processInstanceId
      //   this.formId = data.formId
      //   this.rowData = data
      //   this.drawerShow = true
      // })
    }
    // templateFormAPI.getList(1, -1, { formType: 2 }).then(res => {
    //   this.formList = res.data.data.records
    // })

    const find = this.formList.find(o => o.id === this.formId) || {}
    this.processKey = find.processKey
    this.processInstanceId = find.processInstanceId
    let filterList = []
    if (this.formId === '24') {
      filterList = ['fileIds', 'remark', 'unitName', 'resignation', 'flightDestination', 'lastWorkingDay', 'arrivalDate', 'wpExpiryDate']
    }

    templateFormAPI.detail({ formId: this.formId }).then(res => {
      let temp = res.data.data.records
      temp = temp.filter(el => filterList.indexOf(el.fieldName) === -1)
      const resArr = [
        ...templateFormat(temp), {
          label: this.i18n('status'),
          field: 'STATUSNAME',
          search: true,
          searchBase: true,
          type: 'select',
          dictBizCode: 'process_status',
          sort: -1,
        },
      ]
      this.option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: row => row.STATUS === 1, // 删除按钮(默认 true)

        search: false, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns: resArr,
      }
      this.onLoad(this.page)
    })
  },
  methods: {
    async onLoad(page, params = {}) {
      // this.loading = true
      let res = {}
      if (this.viewAll) {
        res = await applyAPI.getWorkerList(page.currentPage, page.pageSize, Object.assign(params, this.query, { formId: this.formId }))
      } else {
        res = await applyAPI.getWorkerSelfList(page.currentPage, page.pageSize, Object.assign(params, this.query, { formId: this.formId }))
      }
      // const res = await applyAPI.getWorkerList(page.currentPage, page.pageSize, Object.assign(params, this.query, { formId: this.formId }))
      const { data } = res.data;
      this.page.total = data.total;
      const temp = data.records
      this.data = data.records
      // this.data = temp
      const formatData = []
      temp.forEach(item => {
        const form = item.map
        form.id = item.id
        form.processInstanceId = item.processInstanceId
        form.STATUS = item.status
        form.STATUSNAME = item.statusName
        formatData.push(form)
      })
      this.formatData = formatData
      // this.loading = false
    },
    // 点击下载按钮
    handleDownload() {
      if (this.viewAll) {
        downLoadAllLeaveJob(this.query).then(res => {
          this.getBlobObj(res.data, 'Leave Job.xlsx')
        })
      } else {
        downLoadLeaveJob(this.query).then(res => {
          this.getBlobObj(res.data, 'Leave Job.xlsx')
        })
      }
    },
    getBlobObj(context, fileName) {
      const blob = new Blob([context]);
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url
      a.download = fileName
      a.click();
      window.URL.revokeObjectURL(url);
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase());
    },
    findData(key) {
      console.log(this.data, 'data1111===')
      let res = {}
      if (this.processInstanceId) {
        res = this.data.find(o => o.processInstanceId === this.processInstanceId) || {}
      } else {
        res = this.data.find(o => o.id === this.rowData.id) || {}
      }
      return res[key]
    },
    // i18n
    i18n(param) {
      return this.$t(`_apply.${param}`)
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      this.query = e
      this.page.currentPage = 1;
      await this.onLoad(this.page, e);
      done();
    },
    // 搜索重置
    searchReset() {
      this.query = {}
      this.onLoad(this.page);
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    // 点击下载按钮
    rowDel(e) {
      applyAPI.remove(e.id).then(() => {
        this.onLoad(this.page);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.danger'),
            variant: 'danger',
          },
        })
      })
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    beforeOpen(done, type) {
      const formatDic = {
        add: 'Add',
        edit: 'Edit',
        view: 'View',
        upload: 'Upload',
      }
      this.drawerTitle = formatDic[type]
      done()
    },
    submitAdd(done, form) {
      const params = form
      applyAPI.add(params).then(() => {
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: this.$t('system.user.tip.success'), // "操作成功!"
        });
        done();
      }).catch(() => {
        done();
      })
    },
    submitEdit(done, form) {
      applyAPI.update(form).then(() => {
        this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: this.$t('system.user.tip.success'), // "操作成功!"
        });
        done();
      }).catch(() => {
        done();
      })
    },
    handleBeforeClose(done) {
      done()
      this.onLoad(this.page)
    },
    handleDrawerClose() {
      this.drawerShow = false
      this.onLoad(this.page);
    },
    getFormOption(key) {
      return this[`${key}Option`] || false
    },
    handleStepChange(key, row) {
      // this.formId = ''
      if (['add'].indexOf(key) !== -1) {
        this.drawerShow = true
      } else if (['edit', 'viewPage'].indexOf(key) !== -1) {
        // this.formId = row.formId
        this.processId = row.id
        this.drawerShow = true
      } else {
        this.modalShow = true
        this.modalTitle = this.$t(`_staff.prompt.base.${key}Title`)
      }
      this.stepMethodKey = key
      this.rowData = row || {}
    },
    // handleFormSelectConfirm() {
    //   this.drawerShow = true
    //   this.formSelectShow = false
    // },
    async handleModelConfirm() {
      this.modalFormLoading = true
      const key = this.stepMethodKey
      if (key === 'send') {
        const option = processOption[this.processId]
        applyAPI.workerSeed({ processId: this.rowData.id }, { option: JSON.stringify(option) }).then(res => {
          this.modalFormLoading = false
          this.modalShow = false
          this.onLoad(this.page);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      }
    },
    getStatusOption(status) {
      return this.statusOption[status] || {}
    },
  },
};
</script>
<style lang="scss">
.interview{
  position: relative;
  .dropdown-menu {
      min-width: 13rem;
  }
}
.audit-container{
  text-align: center;
}
</style>
